import React from 'react';
import DriverPortalLayout from '../components/DriverPortalLayout';
import HeaderPortal from '../components/HeaderPortal';
import OTPForm from './OTPForm';

export interface IOTPPage {}

const OTPPage: React.FC<IOTPPage> = () => {
  return (
    <>
      <HeaderPortal />
      <DriverPortalLayout>
        <OTPForm />
      </DriverPortalLayout>
    </>
  );
};

export default OTPPage;
